module.exports = "<p>\n  empty works!\n</p>\n"